<h2 mat-dialog-title>Unesite vrijeme potrebno za izvrsenje zadatka</h2>
<mat-dialog-content>

  <input type="number" class="form-control form-control-sm"
         placeholder="Unesite broj dana"  [(ngModel)]="days" min="0"><br>
  <input type="number" class="form-control form-control-sm" [(ngModel)]="hours" min="0"
         placeholder="Unesite broj sati"><br>
  <input type="number" class="form-control form-control-sm" [(ngModel)]="min" min="0"
         placeholder="Unesite broj minuta">
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close matDialogClose="false" (click)="closeModal()"> Otkaži</button>
  <button mat-button (click)="save()">Sačuvaj</button>
</mat-dialog-actions>
